import React, {Component} from 'react';
import './slick-theme.css';
import './slick.css';
import './Slide.css';
import Slider from "react-slick";
import {imgSlide1, imgSlide2,imgSlide3} from '../../sharedcomponents/ImageScope';


export default class Slide extends Component {
    render(){
        const settings = {
           
            dots: true,
            lazyLoad: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll:1,
            initialSlide: 0,
            fade:true,
            autoplay:true
          };
        return(
            <div className="Slide-Div" style={{paddingBottom:'40px'}}>
                <Slider {...settings}>
                    <div>
                        <img src={imgSlide1}  className={'img-slide'} alt=""/>
                    </div>
                    <div>
                        <img src={imgSlide2} className={'img-slide'} alt=""/>
                    </div>
                    <div>
                        <img src={imgSlide3}  className={'img-slide'} alt=""/>
                    </div>
                </Slider>
            </div>
        );
    }
}